import { LogIn } from 'lucide-react';

interface LoginScreenProps {
  loginUrl: string;
}

export function LoginScreen({ loginUrl }: LoginScreenProps) {
  return (
    <div className="flex flex-col h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-xl">H</span>
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Hudl Coach</h1>
            <p className="text-sm text-gray-500">Your AI assistant coach</p>
          </div>
        </div>
      </header>

      {/* Login prompt */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg mx-auto mb-6">
            <LogIn className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Sign in to continue</h2>
          <p className="text-gray-600 mb-8">
            You need to be logged in to your Hudl account to use Hudl Coach.
          </p>
          <a
            href={loginUrl}
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-md hover:from-orange-600 hover:to-orange-700 transition-all"
          >
            <LogIn className="w-5 h-5" />
            Log in with Hudl
          </a>
        </div>
      </div>
    </div>
  );
}
